import productManage from '@/router/modules/productManage'
import agricultural from '@/router/modules/agricultural'
export default {
  name: 'Home',
  path: '/home',
  redirect: { name: 'MyPlot' },
  meta: {
    showTabBar: true
  },
  component: () => import('@/views/layout/HomeLayout'),
  children: [
    productManage,
    agricultural
  ]
}
